module.exports = __webpack_public_path__ + "img/به-انتخاب-طراح-2.aa19da1e.png";